var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-modal",
    {
      attrs: {
        "class-name": "profile-field-edit-dictionary-modal",
        active: _vm.displayModal,
        title: _vm.title,
      },
      on: { close: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c("c-button", {
                attrs: { size: "large", label: "Отменить" },
                on: { click: _vm.close },
              }),
              _c("c-button", {
                attrs: { label: "Сохранить", color: "primary", size: "large" },
                on: { click: _vm.submit },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("c-input", {
            staticClass: "search",
            attrs: {
              placeholder: "Поиск по значению",
              clearable: true,
              icon: "search",
            },
            model: {
              value: _vm.query,
              callback: function ($$v) {
                _vm.query = $$v
              },
              expression: "query",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          !_vm.filteredList.length
            ? _c("div", [
                _vm.normalizedQuery.length
                  ? _c("div", { staticClass: "empty-message" }, [
                      _vm._v("Ничего не найдено"),
                    ])
                  : _c("div", { staticClass: "empty-message" }, [
                      _vm._v("В справочнике пока нет значений"),
                    ]),
              ])
            : _vm._e(),
          _c(
            "shadow-scroll-container",
            {
              staticClass: "variants-list",
              class: {
                "need-space": _vm.filteredList.length === 1,
              },
            },
            [
              _c(
                "div",
                { ref: "list" },
                [
                  _c(
                    "transition-group",
                    {
                      attrs: { name: "slide" },
                      on: { "after-enter": _vm.afterEnter },
                    },
                    _vm._l(_vm.filteredList, function (variant) {
                      return _c(
                        "div",
                        {
                          key: variant.unique,
                          staticClass: "variant-wrapper",
                          attrs: { "data-variant": variant.unique },
                        },
                        [
                          variant.unique === _vm.editedVariant
                            ? _c("variant-form", {
                                attrs: { variant: variant, list: _vm.list },
                                on: {
                                  close: function ($event) {
                                    _vm.editedVariant = null
                                  },
                                },
                              })
                            : _c("div", { staticClass: "variant" }, [
                                _c("div", { staticClass: "variant__text" }, [
                                  _vm._v(_vm._s(variant.text)),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "variant__actions" },
                                  [
                                    _c("c-button", {
                                      directives: [
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.html",
                                          value: {
                                            container: "#app",
                                            trigger: "hover blur",
                                            content: "Редактировать",
                                            placement: "top",
                                          },
                                          expression:
                                            "{\n                    container: '#app',\n                    trigger: 'hover blur',\n                    content: 'Редактировать',\n                    placement: 'top',\n                  }",
                                          modifiers: { html: true },
                                        },
                                      ],
                                      staticClass: "variant__edit",
                                      attrs: { icon: "edit", size: "iconic" },
                                      on: {
                                        click: function ($event) {
                                          _vm.editedVariant = variant.unique
                                        },
                                      },
                                    }),
                                    _c("c-button", {
                                      directives: [
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.hover.blur.top",
                                          value: "Удалить",
                                          expression: "'Удалить'",
                                          modifiers: {
                                            hover: true,
                                            blur: true,
                                            top: true,
                                          },
                                        },
                                      ],
                                      staticClass: "variant__remove",
                                      attrs: {
                                        size: "iconic",
                                        icon: {
                                          icon: "trash",
                                          color: "secondary",
                                        },
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeVariant(variant)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("c-button", {
        attrs: {
          size: "small",
          icon: { icon: "plus", color: "primary" },
          label: "Добавить значение",
        },
        on: { click: _vm.addVariant },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }